import React from 'react'
import PropTypes from 'prop-types'
import { FluidFilmLabPageTemplate } from '../../templates/fluid-film-lab-page'

const FluidFilmLabPagePreview = ({ entry, widgetFor }) => (
  <FluidFilmLabPageTemplate
    title={entry.getIn(['data', 'title'])}
    content={widgetFor('body')}
  />
)

FluidFilmLabPagePreview.propTypes = {
  entry: PropTypes.shape({
    getIn: PropTypes.func,
  }),
  widgetFor: PropTypes.func,
}

export default FluidFilmLabPagePreview
